export const DEFAULT_CITY = "default";
export const CURRENT_CITY = "current";
export const COMPARISON_CITY = "comparison";
